export default "__VITE_ASSET__CtqKujhH__"